import React from 'react';
import styles from './ReturnPolicyModal.module.scss';
import loadable from '@loadable/component';

const Modal = loadable(() => import('../../../components/Modal'));

const ReturnPolicyModal = ({ isOpen, closeModal }) => {
  const ModalTitle = () => {
    return <h6 className={styles.modalTitle}>Return policy</h6>;
  };
  return (
    <Modal
      isOpen={isOpen}
      onOverlayClick={closeModal}
      closeModal={closeModal}
      customTitle={<ModalTitle />}
      className={styles.modalReturnPolicy}
    >
      <div className={styles.main}>
        <div>The Company makes refunds in accordance with the Law on Consumer Protection</div>
        <div className={styles.policyItem}>
          <div className={styles.policyField}>Return period:</div>
          <div>14 days</div>
        </div>
        <div className={styles.policyItem}>
          <div className={styles.policyField}>The cost of the return:</div>
          <div>By agreement</div>
        </div>
        <div className={styles.policyItem}>
          <div className={styles.policyField}>Return and exchange conditions:</div>
          <div>
            Article 9 of the current Law of Ukraine{' '}
            <a href="/" target="_blank">
              &quot;On Protection of Consumer Rights&quot;
            </a>{' '}
            provides for the right of a consumer to exchange a non-food product of good quality for a similar product if
            the purchased product does not fit in shape, size, style, color, size or for other reasons cannot be used
            for its intended purpose, if the product has not been used and if its presentation, consumer properties,
            seals, labels and the payment document issued by the seller together with the product are preserved.
          </div>
          <div>
            The seller has no right to refuse to exchange (return) goods that are not included in the list if they meet
            all the requirements set forth in Article 9 of the Law (preserved presentation, labels, seals, payment
            document, etc.).
          </div>
        </div>
        <div className={styles.policyItem}>
          <div className={styles.policyField}>Exceptions:</div>
          <div>
            The Cabinet of Ministers of Ukraine has approved a list of goods of good quality that cannot be exchanged or
            returned (CMU Resolution No. 172 of March 19, 1994).
          </div>
          <div>
            The current exhaustive List is available at the{' '}
            <a href="/" target="_blank">
              link
            </a>
            .
          </div>
        </div>
      </div>
    </Modal>
  );
};

export default ReturnPolicyModal;
